"use strict";

define(['app', 'jquery', '../../utils/windowSize', './base', 'libs/helpers/screen-sizes'], function (app, $, windowSize, Helper, screenSizes) {
  return Helper.extend({
    ui: {
      tab: '.js-tab',
      content: '.js-content'
    },
    events: {
      'click @ui.tab': 'toggleContent'
    },
    options: {
      activeClass: 'is-active',
      animationSpeed: 200,
      animateOnDesktop: false,
      contentClass: 'js-content-',
      hideContentClass: 'is-hidden--loose',
      scrollTo: false,
      toggleActive: false,
      openLastVisitedTab: false,
      storagePostfix: ''
    },
    onRender: function onRender() {
      if (!this.options.openLastVisitedTab) return;
      this.storageKey = 'tabs-helper-' + this.options.storagePostfix;
      var activeTab = 1;
      var tabs = document.querySelector('.tabs--navigation').children;

      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].firstElementChild.dataset.tab === window.localStorage.getItem(this.storageKey)) {
          activeTab = parseInt(window.localStorage.getItem(this.storageKey));
        }
      }

      this.ui.tab.removeClass(this.options.activeClass).filter("[data-tab=".concat(activeTab, "]")).addClass(this.options.activeClass);
      this.ui.content.addClass(this.options.hideContentClass).filter(".".concat(this.options.contentClass).concat(activeTab)).removeClass(this.options.hideContentClass);
    },
    scrollToContainer: function scrollToContainer($el, isScrollable) {
      if (!isScrollable) return false;
      if (!screenSizes.isLessThanMedium()) return false;
      $('body,html').animate({
        scrollTop: $el.parent().offset().top
      }, this.options.animationSpeed);
    },
    toggleContent: function toggleContent(e) {
      e.preventDefault();
      var $el = $(e.currentTarget);
      var tabIndex = $el.data('tab');
      var contentSelector = '.js-content-' + tabIndex;
      var tabSelector = '[data-tab=' + tabIndex + ']';
      var scrollto = this.options.scrollTo;
      var toggleActive = this.options.toggleActive;
      window.localStorage.setItem(this.storageKey, tabIndex);
      this.ui.tab.removeClass(this.options.activeClass);
      this.ui.tab.filter(tabSelector).addClass(this.options.activeClass);
      var animationSpeed = this.options.animationSpeed;

      if (!this.options.animateOnDesktop && !windowSize.isLessThanMedium()) {
        animationSpeed = 0;
      }

      this.ui.content.not(contentSelector).slideUp(animationSpeed);
      var contentTab = this.ui.content.filter(contentSelector);
      var slideTab = this.scrollToContainer.bind(this, $el, scrollto);

      if (!toggleActive || !screenSizes.isLessThanMedium()) {
        return contentTab.slideDown(animationSpeed, slideTab);
      }

      if (!contentTab.hasClass(this.options.activeClass)) {
        $el.removeClass(this.options.activeClass);
      }

      contentTab.slideToggle(animationSpeed, slideTab);
    }
  });
});